import axios from "axios";
import { API_BASE_URL, buildHeaders } from "utils/services";

export const fetchTransactions = async (user, page, limit, startDate, endDate, type, user_id) => {

  try {
    const params = `?page=${page}&limit=${limit}&startDate=${startDate}&endDate=${endDate}&type=${type}${user_id ? `&user_uuid=${user_id}` : ''}`
    const { data } = await axios.get(`${API_BASE_URL}/agbk/transactions${params}`,
      buildHeaders(user)
    );
    return data?.data;
  } catch (error) {
    throw error
  }
}

export const fetchTransactionDetails = async (user, uuid) => {

  try {
    const { data } = await axios.get(`${API_BASE_URL}/agbk/transactions/${uuid}`,
      buildHeaders(user)
    );
    return data?.data;
  } catch (error) {
    throw error
  }
}